<template>
  <NyranSurvivors />
</template>

<script>
  import NyranSurvivors from '../components/NyranSurvivors.vue'

  export default {
    name: 'Home',

    components: {
      NyranSurvivors,
    },
  }
</script>
